<script>
import PolicyReissueDialog from "@/components/app/policyReissue/PolicyReissueDialog.vue";
import QuestionTooltip from "@/components/app/policyReissue/components/QuestionTooltip.vue";
import reissueTypes from "./reissueTypes";
import displaySettings from "@/mixin/displaySettings";

export default {
    name: "PolicyReissueSuccessDialog",
    components: {PolicyReissueDialog, QuestionTooltip, ...reissueTypes},
    props: ['order', 'dialogVisible'],
    mixins: [displaySettings],
    data() {
        return {
            showReIssueForm: false,
            dataForm: {},
            module: null,
        }
    },
    computed: {
        reissueBlock() {
            if (this.module) {
                switch (this.module.name) {
                    case 'vuso': //10: //vuso
                        return 'VusoPolicyCancel';
                    case 'utsk'://17://utsk
                    case 'usg': //9: //usg
                    case 'brock': //12://brock
                    case 'euroins'://20: //euroins
                    case 'etc'://24: //etc
                        return 'StandardPolicyCancel';
                    case 'tas'://11: //tas
                        if (this.order.insurant.customerTypeId === 1) {
                            return 'StandardPolicyCancel';
                        } else {
                            return 'StatementPolicyCancel';
                        }
                    case 'knajza'://15: //knajza
                        return 'KnajzaPolicyCancel';
                    case 'oranta'://18: //oranta
                        return 'OrantaPolicyReissue';
                    default:
                        return 'StatementPolicyCancel';
                }
            } else {
                return null;
            }
        }
    },
    watch: {
        dialogVisible(val) {
            if(val) {
                this.getModule(this.order.moduleId)
            }
        }
    },
    methods: {
        getModule(id) {
            axios.get('/api/modules/' + id).then(response => {
                this.module = response.data;
            })
        },
        reloadPage() {
            location.reload(false)
        },
        closeModal() {
            this.$emit('update:dialogVisible', false);
        },
        policyReIssueForm() {
            this.showReIssueForm = true;
            this.$emit('update:dialogVisible', false);
        },
        checkFormComplete(event) {
            this.isSubmitDisabled = !event
        }
    },
}
</script>

<template>
    <div class="policy-reissue">
        <el-dialog
            :width="isMobile ? '100%' : '20%'"
            :visible.sync="dialogVisible"
            :destroy-on-close="true"
            :before-close="closeModal"
            :show-close="false"
            center
            top="30vh"
            custom-class="p-4"
        >
            <question-tooltip>
                <div class="mt-2">
                    <p>Особливості переоформлення договорів страхування:</p>
                    <ol class="list-left" style="text-align: left; font-size: 12px;">
                        <li>Дозволено змінювати:
                            <ul>
                                <li>Номер авто.</li>
                                <li>VIN-код.</li>
                                <li>Одне з полів даних про клієнта (не у всіх СК).</li>
                            </ul>
                        </li>
                        <li>Не можна змінювати:
                            <ul>
                                <li>Марку/модель авто, рік випуску.</li>
                                <li>Місце реєстрації власника. У разі зміни реєстрації зверніться в чат Viber для консультації щодо довгострокового розірвання.</li>
                            </ul>
                        </li>
                        <li>Потрібно прикріпити заяву на переоформлення:
                            <ul>
                                <li>Інтер-Поліс, ІНГО, ЄСА.</li>
                            </ul>
                        </li>
                    </ol>
                </div>
            </question-tooltip>
            <div slot="title">
                <div class="title mb-1">
                    <div style="margin-bottom: 10px; text-transform: uppercase; color: #EB001B;">УВАГА!</div>
                    Переоформлення договору можливе лише після того, як договір набуде чинності.</div>
                <div class="small-text">
                    Щоб дізнатися більше про особливості переоформлення, натисніть на  "?".
                </div>
            </div>
            <div class="description">
                <div class="mid-text text-left">
                    <div class="mb-1"><b>Ви можете:</b></div>
                    <ol class="list-left-zero">
                        <li>
                            Подати запит на ануляцію поточного полісу та оформити новий.
                        </li>
                        <li>
                            Дочекатися дати початку дії полісу, а потім подати заявку на його переоформлення.
                        </li>
                    </ol>
                </div>
            </div>
            <div slot="footer">
                <el-row>
<!--									@click="$emit('update:dialogVisible', false)"-->

                    <el-col>
                        <el-button
                            type="primary"
                            class="w-100"
                            @click="policyReIssueForm"
                        >Продовжити</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
        <policy-reissue-dialog :order="order" :dialog-visible.sync="showReIssueForm"/>
    </div>
</template>

<style lang="scss" scoped>
@import "./styles/policy-reissue.scss";
</style>
